import { Component, Input } from '@angular/core';

@Component({
  selector: 'navaar-tab-scroll-spy',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {

  @Input('title') public title: string;
  @Input('en-title') public enTitle: string;
  @Input('id') public id: string;

  public active: boolean = false;

  constructor() { }
}
